import React, { Component } from 'react'
import { Select } from '@driftt/tide-core-legacy'
import { api } from 'app/modules/eloqua/api'
import withNotifications from 'components/shared/notifications'
import debounce from 'lodash.debounce'
import './style.styl'

const integrationName = "Eloqua"
const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`
const getErrorMessage = (integrationName) => `There was an error when updating your ${integrationName} App!`

class EloquaCdoSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectOptions: [],
      selectedValue: null
    }

    this.updateSelectOptions = debounce(this._updateSelectOptions, 1000)
  }

  componentDidMount() {
    this.getSelectedCdo()
    this.updateSelectOptions("")
  }

  _updateSelectOptions = async (query) => {
    const { selectedValue } = this.state

    try {
      const eloquaCDOs = await api.fetchEloquaCDOs(query)
      const selectOptions = eloquaCDOs.map(function (cdo) { return ({ label: cdo.name, value: cdo.id }) })

      const cdoIds = new Set(eloquaCDOs.map(function (cdo) { return cdo.id }))

      if (selectedValue != null && !cdoIds.has(selectedValue.id)) {
        selectOptions.push({ label: selectedValue.name, value: selectedValue.id })
      }

      this.setState({
        selectOptions: selectOptions
      })
    } catch(e) {
      console.warn(e)
    }
  }

  getSelectedCdo = async () => {
    try {
      const cdoConfig = await api.fetchEloquaCdoConfig()
      const cdoId = cdoConfig.objectId
      const cdoName = cdoConfig.objectName

      if (cdoId != undefined) {
        this.setState({ selectedValue: { name: cdoName, id: cdoId }})
      }
    } catch(e) {
      console.warn(e)
    }
  }

  saveSelectedCdo = async () => {
    const { notifications } = this.props
    const { selectedValue } = this.state

    try {
      const objectId = selectedValue ? selectedValue.id : null
      const objectName = selectedValue ? selectedValue.name : null
      await api.patchEloquaCdoConfig({ objectId: objectId, objectName: objectName })
      notifications.success(getSuccessMessage(integrationName))
    } catch(e) {
      console.warn(e)
      notifications.error(getErrorMessage(integrationName))
    }
  }

  onSelectStateChange = async () => {
    const { refreshEloquaFields } = this.props

    await this.saveSelectedCdo()
    await refreshEloquaFields()
  }

  handleSelectChange = selectedOption => {
    let newValue

    const selectionCleared = !selectedOption
    if (selectionCleared) {
      newValue = null
    } else {
      newValue = { id: selectedOption.value, name: selectedOption.label }
    }

    this.setState({
      selectedValue: newValue
    }, this.onSelectStateChange)
  }

  render() {
    const { selectOptions, selectedValue } = this.state

    return (
      <Select 
        className={'eloqua-cdo-select'}
        options={selectOptions}
        value={selectedValue ? selectedValue.id : null}
        disabled={false}
        onChange={this.handleSelectChange}
        onInputChange={this.updateSelectOptions}
      />
    )
  }
}

export default withNotifications(EloquaCdoSelect)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaAttributeMappingCdo/EloquaCdoSelect.js